import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useBasket } from '../../context/BasketContext';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Riple } from "react-loading-indicators";
import { API_BASE_URL } from '../../constants/api';

const Checkout = () => {

    const navigate = useNavigate();
    const { basket, clearBasket } = useBasket();
    const [isLoading, setIsLoading] = useState(false);
    const [invalidSlotIds, setInvalidSlotIds] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        initBootstrapComponents();
    }, []);

    // Format date to match the design
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    // Format time to match the design
    const formatTime = (dateTimeString) => {
        return new Date(dateTimeString).toLocaleTimeString('en-GB', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase();
    };

    // Group slots by date
    const groupedSlots = basket?.slots?.reduce((acc, slot) => {
        const date = formatDate(slot.date);
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(slot);
        return acc;
    }, {});

    const customerDetails = JSON.parse(localStorage.getItem('customerDetails'));

    const handlePlaceOrder = async () => {
        setIsLoading(true);
        setErrorMessage(""); // Clear any previous error messages
        try {
            // const bookingIds = JSON.parse(localStorage.getItem('bookingIds') || '[]');
            const customerDetails = JSON.parse(localStorage.getItem('customerDetails'));

            const formDataObj = new FormData();
            
            // Add each booking ID to formData
            basket.slots.forEach(slot => {
                formDataObj.append('bookings[]', Number(slot.booking_id));
            });

            formDataObj.append('customer[email]', customerDetails.email);
            formDataObj.append('customer[title]', customerDetails.title);
            formDataObj.append('customer[first_name]', `${customerDetails.firstName}`);
            formDataObj.append('customer[last_name]', customerDetails.lastName);
            formDataObj.append('customer[telephone]', customerDetails.telephone);
            formDataObj.append('customer[house_number]', customerDetails.houseNumber);
            formDataObj.append('customer[postcode]', customerDetails.postcode);
            formDataObj.append('customer[address_line_1]', customerDetails.addressLine1);
            formDataObj.append('customer[address_line_2]', customerDetails.addressLine2);
            const ambassadorId = localStorage.getItem('ambassador_id');
            if (ambassadorId) {
                formDataObj.append('ambassador_id', ambassadorId);
            }
            formDataObj.append('customer[is_existing_motability_scheme_customer]', customerDetails.isExistingCustomer);
            formDataObj.append('customer[marketing_consent]', customerDetails.marketingConsent);
            formDataObj.append('key', '7678356c642c91a255471d162205e0f3');

            const token = localStorage.getItem('ambassador_token');

            const headers = {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'multipart/form-data'
            };
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            const resp = await axios.post(`${API_BASE_URL}/api/events/bookings/finalise`, formDataObj, {
                headers,
                withCredentials: true
            });

            const failedMessage = resp.data.data?.failedMessage;
            if (failedMessage) {
                setErrorMessage(failedMessage);
                return;
            }

            // Clear the booking IDs from localStorage
            // localStorage.removeItem('bookingIds');
            localStorage.setItem('bookingConfirmation', JSON.stringify(resp.data.data));
            
            // Clear the basket before navigation
            clearBasket();
            
            // Navigate to confirmation page
            navigate('/booking-confirmation');
        } catch (error) {
            console.error('Booking error:', error);
            console.error('Full error object:', error.response);

            // Handle the specific error case for duplicate email
            if (error.response?.data?.status === "There is already a registered user with the same email but different type. Please choose a different email.") {
                setErrorMessage("This email address is already registered with a different account type. Please use a different email address.");
            }
            // Parse booking errors if they exist
            else if (error.response?.data?.errors) {
                const errors = error.response.data.errors;
                const invalidSlots = [];
                Object.keys(errors).forEach(key => {
                    if (key.startsWith('bookings.')) {
                        const slotIndex = key.split('.')[1];
                        // Try to get the slot ID from bookingIds array
                        // const bookingIds = JSON.parse(localStorage.getItem('bookingIds') || '[]');
                        // const bookingObj = bookingIds[slotIndex];
                        // if (bookingObj && bookingObj.slotId) {
                        //     invalidSlots.push(Number(bookingObj.slotId));
                        // }

                        setErrorMessage("Invalid Booking")
                    } 
                });
                setInvalidSlotIds(invalidSlots);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="bg-motability-mid-black-5 py-32 pt-lg-96 pb-lg-411" id="book-a-test-drive-booking-confirmation">
                    <div className="container">
                        <h1 className="text-primary mb-4 mb-lg-5">
                            Checkout
                        </h1>

                        {errorMessage && (
                            <div className="alert alert-danger mb-4" role="alert">
                                {errorMessage}
                            </div>
                        )}

                        <div className="bg-motability-white border border-motability-light-blue rounded-4 p-4 p-lg-32">
                            <h6 className="text-primary text-uppercase fw-medium mb-3">
                                {basket.event?.name || 'Event'}
                            </h6>

                            <div className="row row-gap-4 row-gap-lg-0 gx-xxl-5">
                                <div className="col-lg-6">
                                    <h6 className="text-primary mb-3">
                                        Guest details
                                    </h6>

                                    <p className="fw-semibold mb-2">
                                        <span className="fw-semibold">Name:</span> {customerDetails?.firstName} {customerDetails?.lastName}
                                    </p>

                                    <p className="mb-2">
                                        <span className="fw-semibold">Phone:</span> {customerDetails?.telephone}
                                    </p>

                                    <p className="mb-0">
                                        <span className="fw-semibold">Email:</span> {customerDetails?.email}
                                    </p>

                                    <p className="mb-0">
                                        <span className="fw-semibold">House/Flat Number:</span> {customerDetails?.houseNumber}
                                    </p>

                                    <p className="mb-0">
                                        <span className="fw-semibold">Postcode:</span> {customerDetails?.postcode}
                                    </p>
                                    
                                    
                                </div>

                                <div className="col-lg-6">
                                    <div className="bg-motability-mid-black-5 border border-motability-mid-black-2 rounded-4 p-4 p-lg-32">
                                        <h5 className="text-primary mb-3">
                                            Your order
                                        </h5>

                                        <div className="order-items">
                                            {basket?.slots?.map((slot) => (
                                                <div key={slot.id} className="order-item py-3 d-flex align-items-center gap-3">
                                                    {slot.vehicle?.images_array?.[0] && (
                                                        <div className="vehicle-image-container" style={{ width: '120px', flexShrink: 0 }}>
                                                            <img 
                                                                src={slot.vehicle.images_array[0]} 
                                                                alt={slot.vehicle.name}
                                                                className="img-fluid rounded-3"
                                                                style={{ width: '100%', height: 'auto' }}
                                                            />
                                                        </div>
                                                    )}
                                                    <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3 flex-1">
                                                        <div className="d-flex flex-column">
                                                            <p className="fw-semibold mb-0">
                                                                {basket.event_name && basket.event_name}
                                                            </p>
                                                            <p className="fw-semibold mb-0">
                                                                {slot.vehicle?.name + ' -  ' + slot.vehicle?.number}
                                                            </p>
                                                            <p className="fw-semibold mb-2">
                                                                {new Date(slot.start_at).toLocaleDateString('en-GB', {
                                                                    weekday: 'long',
                                                                    day: 'numeric',
                                                                    month: 'long',
                                                                    year: 'numeric'
                                                                })}
                                                            </p>
                                                            <p className="mb-0" id="booked-from-date">
                                                                <span className="fw-semibold">Time:</span> {formatTime(slot.start_at)}
                                                            </p>
                                                            {invalidSlotIds.includes(Number(slot.id)) && (
                                                                <p className="text-danger mt-1 mb-0 small fw-semibold">{"Invalid slot - return to basket and remove"}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            <div>
                                                <button 
                                                    type="submit" 
                                                    className="btn btn-primary px-29 d-flex align-items-center justify-content-center gap-2" 
                                                    onClick={handlePlaceOrder}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <Riple color="#FFFFFF" size="small" />
                                                            <span>Processing...</span>
                                                        </>
                                                    ) : (
                                                        'Place order'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Checkout;
